import React        from 'react';
import { Redirect } from 'react-router-dom';
import AuthList     from './AuthList';
import Auth         from './Auth';
import PasswordEdit from './PasswordEdit';

export const AuthCrudConfig = {
    routes  : [
        {
            path      : '/user/list',
            component : AuthList,
            permission: { component_name: 'user', permission_type: 'list' },
        },
        {
            path      : '/user/change_password/:auth_id',
            component : PasswordEdit,
            permission: { component_name: 'user', permission_type: 'edit' },
        },
        {
            path      : '/user/:view_type/:auth_id',
            component : Auth,
            permission: { component_name: 'user', permission_type: 'view_type' },
        },
        {
            path      : '/user/:view_type/',
            component : Auth,
            permission: { component_name: 'user', permission_type: 'view_type' },
        },
        {
            path      : '/user',
            component : () => <Redirect to="/user/list" />,
            permission: { component_name: 'user', permission_type: 'list' },
        }
    ]
};



// WEBPACK FOOTER //
// src/main/content/auth/AuthCrudConfig.js